import { motion } from "framer-motion";
import { Reveal, SectionTag } from "./Reveal";
import { scrollToForm } from "../config";

const STEPS = [
  { n: "1", title: "Request Your Review", copy: "Share your contact details and approximate monthly card volume." },
  { n: "2", title: "Review Your Processing", copy: "A payment specialist will help you gather the information needed to assess your current costs." },
  { n: "3", title: "Decide What Makes Sense", copy: "Review the findings and decide whether switching is right for your business." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-24 sm:py-28">
    <SectionTag index="03" label="How It Works" center />
    <Reveal className="mx-auto mt-6 max-w-2xl text-center">
      <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
        Three Steps. <span className="text-mint">No Guesswork.</span>
      </h2>
    </Reveal>

    <div className="mx-auto mt-14 max-w-3xl">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.1}>
          <div data-testid={`how-step-${s.n}`} className="relative flex gap-6 pb-12 last:pb-0">
            {i < STEPS.length - 1 && (
              <span className="absolute left-7 top-16 h-[calc(100%-4rem)] w-px bg-white/10" />
            )}
            <motion.span
              initial={{ scale: 0.6, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-mint bg-void font-mono text-xl font-bold text-mint shadow-[0_0_24px_rgba(0,156,222,0.3)]"
            >
              {s.n}
            </motion.span>
            <div className="pt-1.5">
              <h3 className="font-display text-2xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-2 max-w-lg leading-relaxed text-white/60">{s.copy}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal className="mx-auto mt-12 max-w-2xl text-center">
      <p className="text-white/60">
        If you choose to switch, our team will explain the setup and transition process.
      </p>
      <button
        data-testid="how-cta"
        onClick={scrollToForm}
        className="mt-8 rounded-full bg-mint px-8 py-4 font-display text-base font-bold text-cream transition-transform duration-300 hover:scale-105 hover:brightness-110"
      >
        Request My Free Savings Review →
      </button>
    </Reveal>
  </section>
);
